import { useState, Fragment, useContext } from "react";
import { Grid, Container } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";

import { Margin } from "../styles/GerenciamentoContrato";
import MaskService from "../../../../utils/mask/maskService";

import TableDefault from "../../../../components/grid/TableDefault";
import ModalCancelaServicoAvulso from "./ModalCancelaServicoAvulso";
import useGerenciamentoContratoListagemController from "../controllers/GerenciamentoContratoListagemController";
import { ConfigurationContext } from "../contexts/ConfigurationContext";

const TabAvulso = ({ content, setContent, setCrRows }) => {
  const { configuration } = useContext(ConfigurationContext);

  const [modalCalcelaServiceOpen, setModalCalcelaServiceOpen] = useState(null);

  const { removeServicoAvulso } = useGerenciamentoContratoListagemController();
  const [serviceCancelId, setServiceCancelId] = useState(null);

  const cancelaServicoAvulso = async (id) => {
    const copy = content;

    const cancelamentoAvulso = await removeServicoAvulso(
      id,
      content[0].idcr_avulso,
      setCrRows,
      content,
      setContent
    );

    if (cancelamentoAvulso) {
      const index = copy.findIndex((e) => e.id === id);
      copy[index] = {
        ...copy[index],
        rowError: true,
      };
      setContent((e) => ({ ...e, despesas: copy }));
    }

    return;
  };

  const handleCancelaServico = async (id) => {
    setModalCalcelaServiceOpen(true);
    setServiceCancelId(id);
  };

  const columns = [
    {
      id: "id",
      label: "ID",
    },
    {
      id: "descricao",
      label: "Descrição",
      format: (value) => value?.contratoservicos?.descricao,
    },
    {
      id: "quantidade",
      label: "Quantidade",
    },
    {
      id: "valortotal",
      label: "Valor",
      format: (value) =>
        `R$ ${
          value?.valortotal
            ? MaskService.toMask(
                "decimal",
                parseFloat(value?.valortotal).toFixed(
                  configuration?.contract_decimal_size || 2
                ),
                configuration?.contract_decimal_size || 2
              )
            : `0,${"0".repeat(configuration?.contract_decimal_size || 2)}`
        }`,
    },
    {
      label: "Cancela Serviço",
      name: "cancelar",
      format: (value) =>
        !value.motivocancelamento_id &&
        !value.rowError && (
          <BlockIcon
            style={{ cursor: "pointer" }}
            color="error"
            onClick={() => {
              handleCancelaServico(value?.id);
            }}
          />
        ),
    },
  ];

  return (
    <>
      {modalCalcelaServiceOpen && (
        <ModalCancelaServicoAvulso
          open={modalCalcelaServiceOpen}
          setOpen={setModalCalcelaServiceOpen}
          handleMain={() => cancelaServicoAvulso(serviceCancelId)}
        />
      )}
      <Margin top={25}>
        <Container maxWidth="lg">
          <Margin top={25}>
            <Grid item xs={12}>
              <TableDefault
                tableTitle=""
                columns={columns}
                values={content.map((row) => {
                  return {
                    ...row,
                    rowError: row.rowError || row.motivocancelamento_id,
                  };
                })}
                minHeight="350px"
                orderSort="desc"
                selectedByRow={true}
                rowsPerPage={content?.length}
                disabledDefaultPagination
                disabledEmptySpace
              />
            </Grid>
          </Margin>
        </Container>
      </Margin>
    </>
  );
};

export default TabAvulso;
